const router = [
  {
    path: '/reports',
    name: 'reports',
    redirect: '/reports/main',
    component : () => import('@/modules/Reports/pages'),
    children: [
      {
        path: '/reports/main',
        name: 'report-main',
        component : () => import('@/modules/Reports/pages/reports'),
        meta: {
          requiresAuth: true,
          requiresPermission: true,
          action: 38
        }
      }
    ],
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 38
    }
  }
]

export default router